import * as i0 from "@angular/core";
export class SessionStorageService {
    constructor() { }
    /**
     * @param item item name
     * @param shouldRemove Flag to determine if it should be removed from storage after retrieving value
     * @returns parsed sessionStorage data or null value
     */
    getValue(item, shouldRemove = false) {
        const data = this.getItem(item);
        if (data && shouldRemove) {
            this.removeItem(item);
        }
        try {
            return JSON.parse(data);
        }
        catch (e) {
            return null;
        }
    }
    /**
     * @param item item name
     * @param value object value stored as string
     */
    setValue(item, value) {
        this.setItem(item, JSON.stringify(value));
    }
    /**
     * Returns the session storage value
     * @param key The session storage key
     */
    getItem(key) {
        return sessionStorage.getItem(key);
    }
    /**
     * Persists and item in the session storage
     * @param key The session storage key
     * @param value The session storage value
     */
    setItem(key, value) {
        sessionStorage.setItem(key, value);
    }
    /**
     * Removes an item from the session storage
     * @param key The session storage key
     */
    removeItem(key) {
        sessionStorage.removeItem(key);
    }
}
SessionStorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SessionStorageService_Factory() { return new SessionStorageService(); }, token: SessionStorageService, providedIn: "root" });
